import { ILinkResponse, Link } from "types/link";
import { ApiService } from "./Api.service";

export class LinkAPIService {
	static async getLink(linkId: string): Promise<ILinkResponse> {
		return ApiService.fetch(`app-links/${linkId}/resolved`);
	}
}

export class LinkService {
	static async getLink(linkId: string): Promise<Link> {
		return LinkAPIService.getLink(linkId).then((data: ILinkResponse) => new Link(data));
	}
}
